import { css } from 'styled-components';

/**
 * Hover-reveal styling for the copy-setting trigger. Apply this to the row/wrapper
 * element that contains a setting control and its <CopySettingToLocations /> button:
 * the button stays invisible (but keyboard-focusable) until the row is hovered or
 * the button receives focus, so settings pages don't accumulate visual noise.
 *
 *   const Row = styled.div`
 *     display: flex;
 *     align-items: center;
 *     ${copySettingRevealCss}
 *   `;
 *
 * Kept free of component imports so low-level style modules can use it without
 * pulling in the component (and its modal/apollo dependencies).
 */
export const copySettingRevealCss = css`
  [data-copy-setting-trigger] {
    opacity: 0;
    transition: opacity 120ms ease-in-out;
  }

  &:hover [data-copy-setting-trigger],
  &:focus-within [data-copy-setting-trigger] {
    opacity: 1;
  }
`;
